import styled from 'styles/styled';

export const LinkWrapper = styled.a`
  width: 34px;

  @media ${({ theme }) => theme.devices.large} {
    width: 24px;
  }
`;
